import { lazy } from "react";
import { MapPinned } from "lucide-react";

import type { FeatureDescriptor } from "@/features/types";

export const localitiesFeature: FeatureDescriptor = {
  id: "localities",
  flag: "localities",
  path: "/localities",
  group: "operate",
  navKey: "nav.localities",
  icon: MapPinned,
  element: lazy(() => import("./LocalitiesPage")),
  subRoutes: [{ path: "/localities/:name", element: lazy(() => import("./LocalityDetailPage")) }],
};
